// import ResourceItem from "@/components/vehicles/ResourceItem.vue";
// import CustomerItem from "@/components/customers/CustomerItem.vue";
// import DocumentItem from "@/components/documents/DocumentItem.vue";

import CustomerItem from "@/contrib/customers/components/CustomerItem.vue";
import SupplierItem from "@/contrib/suppliers/components/SupplierItem.vue";
import DocumentItem from "@/contrib/documents/DocumentItem.vue";
import JobItem from "@/contrib/jobs/components/JobItem.vue";

export default {
    jobs: {
        url: "/magonetjobs/",
        args: {limit: 100},
        verbose_name: "Commessa",
        verbose_name_plural: "Commesse",
        component: JobItem,
        require: "magonet.view_magonetjobs",
    },
    customers: {
        url: "/magonetcustomers/",
        args: {limit: 100},
        verbose_name: "Cliente",
        verbose_name_plural: "Clienti",
        component: CustomerItem,
        require: "magonet.view_magonetcustomers",
    },
    suppliers: {
        url: "/magonetsuppliers/",
        args: {limit: 100},
        verbose_name: "Fornitore",
        verbose_name_plural: "Fornitori",
        component: SupplierItem,
        require: "magonet.view_magonetsuppliers",
    },
    documents: {
        url: "/dmsarchiveddocument/",
        verbose_name: "Documento",
        verbose_name_plural: "Documenti",
        component: DocumentItem,
        require: "magonet.view_dmsarchiveddocument",
    },
};
